import { useTranslation } from "react-i18next"
import { Modal, Button, Toast, useToast } from "@oysterhr/ui"

import { B2BPaymentMethod, CorePaymentMethod, Maybe } from "@oysterhr/schema"

import { useDeletePaymentMethod } from "../actions"

interface ReplacePaymentMethodModalProps {
  isOpen: boolean
  onClose: () => void
  paymentMethod?: Maybe<CorePaymentMethod | B2BPaymentMethod>
  onDeletionSuccess?: () => void
}

export const ReplacePaymentMethodModal = ({
  isOpen,
  onClose,
  paymentMethod,
  onDeletionSuccess,
}: ReplacePaymentMethodModalProps) => {
  const toast = useToast()
  const { t } = useTranslation(
    "company_interface/CompanyPaymentMethodsPage/ReplacePaymentMethodModal",
  )

  const { deletePaymentMethod, loading } = useDeletePaymentMethod({
    successCallback: () => {
      toast({
        render: (
          <Toast>
            <Toast.Content>{t("deleted")}</Toast.Content>
          </Toast>
        ),
      })
      onDeletionSuccess?.()
      onClose()
    },
    failureCallback: errors => {
      toast({
        render: (
          <Toast variation="error">
            <Toast.Content>{errors.join(", ")}</Toast.Content>
          </Toast>
        ),
      })
    },
  })

  if (!paymentMethod) return null

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose}>
      <Modal.Header>{t("title")}</Modal.Header>
      <Modal.Content>{t("description")}</Modal.Content>
      <Modal.Footer>
        <Button variation="outline" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button
          data-analytics-name="company_payment_methods-remove-payment-method"
          variation="danger"
          isLoading={loading}
          onClick={() => {
            deletePaymentMethod(paymentMethod)
          }}
        >
          {t("submit")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
